import React from 'react'
import { Helmet } from 'react-helmet';
import { TeamData } from '../data/TeamData';
const Team = () => {
  return (
    <div>
      <Helmet>
        <title>Our Team</title>
      </Helmet>
      <div className='main-container'>
        <div className="page-bg"></div>
        <div className="page-bg page-bg2"></div>
        <div className="page-bg page-bg3"></div>

        <div className="section">
          <div className="team-section">
            <div className="page-heading">
              <h1>Our Team</h1>
            </div>
            <div className="grid-4">
              {TeamData.map((member, index) => {
                return (
                  <div className='team-cards' key={index}>
                    <div className="team-card-image">
                      <img src={member.Image} alt="Team Member" />
                    </div>
                    <div className="team-card-desc">
                      <h2>{member.Name}</h2>
                      <h3>{member.Designation}</h3>
                    </div>
                  </div>
                )
              })}

            </div>

          </div>




        </div>

      </div>

    </div>
  )
}

export default Team